var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.573L5.24422 18.2333C5.11352 18.3021 4.96689 18.3349 4.81934 18.3284C4.67179 18.3218 4.52862 18.2762 4.4045 18.1962C4.28037 18.1162 4.17974 18.0046 4.11292 17.8729C4.0461 17.7411 4.01549 17.594 4.02422 17.4466L4.03505 17.3549L4.94338 12.0591L1.09172 8.30994C0.985896 8.2072 0.909239 8.07822 0.869572 7.93616C0.829905 7.79411 0.82865 7.64407 0.865934 7.50137C0.903219 7.35868 0.977707 7.22843 1.08179 7.12394C1.18588 7.01944 1.31583 6.94445 1.45838 6.9066L1.55255 6.88744L6.86922 6.1166L9.24672 1.29994C9.31549 1.16038 9.42195 1.04286 9.55406 0.960689C9.68616 0.878514 9.83864 0.834961 9.99422 0.834961C10.1498 0.834961 10.3023 0.878514 10.4344 0.960689C10.5665 1.04286 10.6729 1.16038 10.7417 1.29994L12.9563 5.7882",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 5,
    stroke: "#666666",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3144L13.2 15.6001L16 12.6001",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.6667,
    cy: 5.66667,
    r: 1.66667,
    fill: "#F7E237"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_1298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCategory);
export default __webpack_public_path__ + "static/media/search_category.cc1c11e9be469d62526b6dc406cdeabb.svg";
export { ForwardRef as ReactComponent };